import React, { useEffect, useState } from 'react';
import VendorModel from './models/VendorModel';

function DeleteVendor({ VendorData }) {
  const [selected, setSelected] = useState(new VendorModel());

  useEffect(() => {
    setSelected(VendorData || new VendorModel());
  }, [VendorData]);

  return (
    <div className="text-left px-2 pb-0">
      <h6>Following vendor will be deleted and cannot be recovered:</h6>
      <ul>
        <li>
          <b>Vendor Name:</b> {selected.VendorName}
        </li>
        <li>
          <b>Email:</b> {selected.Email || 'N/A'}
        </li>
        <li>
          <b>Contact Number:</b> {selected.ContactNumber || 'N/A'}
        </li>
      </ul>
    </div>
  );
}

export default DeleteVendor;
